// captchaSign 文档
// https://md.office.k8s.xunlei.cn/DBdqxXjlQb29tq4ZcSDJ5Q?view

import { SSOconfig } from './config'
import md5 from 'blueimp-md5'
import getPubKey from '@remote/api/get-pub-key.esm'
import pkg from '../../package'
import { Algorithms } from './algorithms'

let algorithms = Algorithms

console.log('SSOconfig :>> ', SSOconfig)
// 生成签名
export async function getPubKeySign ({ timestamp, deviceId }) {
  try {
    let deviceid = deviceId
    // 初始化: captchaSign = client_id + client_version + package_name + device_id + timestamp (timestamp精确到毫秒)
    let captchaSign = `${SSOconfig.clientId}${pkg.version}${location.host}${deviceid}${timestamp}`

    // console.log('1.----captchaSign :>> ', captchaSign);
    if (!algorithms.length) {
      const pubKeyInfo = await getPubKey()
      algorithms = pubKeyInfo.algorithms
    }
    algorithms.forEach((item) => {
      captchaSign = md5(`${captchaSign}${item.salt}`)
    })

    captchaSign = `${SSOconfig.algVersion}.${captchaSign}`
    // console.log('2.----captchaSign :>> ', captchaSign);
    return captchaSign
  } catch (error) {
    console.log(error)
  }
}
